import { RouteComponentProps } from '@reach/router';
import { ResourcesApi } from 'api/resourcesApi';
import ResourcePageStatus from 'components/resources/ResourcePageStatus';
import {
  awesomeStuffPath,
  isPageData,
  ResourcesRouteParams,
  resourcesByActivityPath,
  usePageTitle,
  useResourcesPage,
} from 'components/resources/resourcesHelpers';
import ResourceSearchBox from 'components/resources/ResourceSearchBox';
import ResourceTile from 'components/resources/ResourceTile';
import SubjectSiteContainerFixed from 'components/subjectSite/SubjectSiteContainerFixed';
import SubjectSiteLayout from 'components/subjectSite/SubjectSiteLayout';
import GeneralResourcesImage from 'images/resources/General_Resources.png';
import ResourcesByActivityImage from 'images/resources/Resources_By_Activity.png';
import React from 'react';

type Props = RouteComponentProps<ResourcesRouteParams>;

/** Refuses the page to a school without full access */
const loadAccess = (subjectsId: number) =>
  ResourcesApi.getCategories(subjectsId).then((categories) =>
    typeof categories === 'string' || categories.access.status === 'Full'
      ? categories
      : 'notFound'
  );

const ResourceBankHome: React.FC<Props> = ({ subject: subjectCode }) => {
  const result = useResourcesPage(subjectCode, loadAccess, '', false);
  usePageTitle(
    isPageData(result) ? `${result.subject.name} - Resource Bank` : null
  );

  if (!isPageData(result)) return <ResourcePageStatus result={result} />;

  const { subject, labels } = result;
  const code = subject.internalCode;

  return (
    <SubjectSiteLayout colorCss="Blue_GSFPE">
      <SubjectSiteContainerFixed className="ResourceBankLanding">
        <div className="WidthContent">
          <h1 className="Title">Awesome Stuff</h1>
          <div className="TitleAndSearchWrapper">
            <ResourceSearchBox
              subjectCode={code}
              placeholder="Please enter search..."
            />
          </div>
          <p className="Subtitle"></p>
          <div className="WrapperKeyStage">
            <ResourceTile
              className="Item"
              name="General Resources"
              imageSrc={GeneralResourcesImage}
              imageAlt="EYFS"
              to={awesomeStuffPath(code)}
            />{' '}
            <ResourceTile
              className="Item"
              name={labels.ResourcesByActivity ?? ''}
              imageSrc={ResourcesByActivityImage}
              imageAlt="EYFS"
              to={resourcesByActivityPath(code)}
            />
          </div>
        </div>
      </SubjectSiteContainerFixed>
    </SubjectSiteLayout>
  );
};

export default ResourceBankHome;
